import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import LoadingTable from "./LoadingTable";

import * as paymentAction from "../actions/paymentActions";

import { formatDate, formatMoney, isExpired } from "../helpers/utils";

/**
 * Płatności kontrahenta
 */
class RestaurantPayments extends React.Component {

    state = {
        //czy dane do tabelki sie zaladowaly
        loading: true
    };

    componentDidMount() {

        this._isMounted = true;

        //ladowanie danych do tabelki
        let restaurantId = this.props.companyId;

        //pobieramy platnosci dla restauracji i dopiero po pobraniu ustawiamy loading na false

        this.props.onFetch(restaurantId, () => {
            //po pobraniu danych do tabelki zmieniamy stan na zaladowany jesli jeszcze komponent jest aktywny
            if (this._isMounted) {
                this.setState({ loading: false });
            }
        });

    }

    componentWillUnmount() {
        this.props.onClear();
    }

    /**
     * Kolumny do tabelki
     */
    tableColumns = [
        {
            Header: this.props.formatMessage("payment.faktura"),
            accessor: "faktura",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "center" },
            minWidth: 80,
        },
        {
            Header: this.props.formatMessage("payment.dataWystawienia"),
            id: "dataWystawienia",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "center" },
            minWidth: 120,
            accessor: data => {
                return formatDate(data.dataWystawienia);
            },
        },
        {
            Header: this.props.formatMessage("payment.terminPlatnosci"),
            id: "terminPlatnosci",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "center" },
            minWidth: 120,
            accessor: data => {
                return formatDate(data.terminPlatnosci);
            },
        },
        {
            Header: this.props.formatMessage("payment.zaplacono"),
            id: "zaplacono",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            minWidth: 80,
            Cell: row => {
                //na niebiesko, zapłacone
                return (
                    <span className={row.original.zaplacono > 0 ? 'w3-text-theme-dark' : ''}>
                        {formatMoney(row.original.zaplacono)}
                    </span>
                )
            }
        },
        {
            Header: this.props.formatMessage("payment.doZaplaty"),
            accessor: "doZaplaty",
            headerStyle: { whiteSpace: "unset" },
            style: { whiteSpace: "unset", textAlign: "right" },
            minWidth: 145,
            Cell: row => {
                //na czerwono, niezapłacone z przekroczonym terminem płatności
                return (
                    <span className={isExpired(row.original.terminPlatnosci) && row.original.doZaplaty > 0 ? 'w3-text-red' : ''}>
                        {formatMoney(row.original.doZaplaty)}
                    </span>
                )
            },
            Footer: info => {

                // Liczymy tylko jeśli wiersze się zmieniły, bez tego obliczamy przy resize/pagination/sort
                const totalDoZaplaty = React.useMemo(
                    () =>
                        info.data.reduce((sum, row) => row.doZaplaty + sum, 0),
                    [info.data]
                )

                return <b className={totalDoZaplaty > 0 ? 'w3-text-red' : ''}>{this.props.formatMessage('app.restaurantPaymentList.summary', { total: formatMoney(totalDoZaplaty) })}</b>

            }
        }

    ]

    render() {

        const { formatMessage } = this.props;

        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">{formatMessage('app.restaurantPaymentList.title', { restaurantName: this.props.companyName })}</h2>
                </div>

                <div className="w3-container">
                    <LoadingTable
                        data={this.props.restaurantPaymentList}
                        columns={this.tableColumns}
                        loading={this.state.loading}
                        filterable={false}
                        showPagination={false}
                    />
                </div>

                <div className="w3-bar">
                    <button
                        className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                        onClick={this.props.onClose}
                    >
                        {formatMessage("app.restaurantPaymentList.action.close")}
                    </button>
                </div>
            </div>
        )
    }
}

RestaurantPayments.propTypes = {
    /**
    * Określa identyfikator restauracji
    */
    companyId: PropTypes.number.isRequired,
    /**
    * Określa nazwę restauracji
    */
    companyName: PropTypes.string.isRequired,
    /**
     * Określa funkcję na zamknięcie okna
     */
    onClose: PropTypes.func.isRequired,
    /**
     * Metoda tłumacząca
     */
    formatMessage: PropTypes.func.isRequired,
    /**
     * Lista płatności dla podanej restauracji
     */
    restaurantPaymentList: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    restaurantPaymentList: state.paymentReducer.restaurantPaymentList
});

const mapDispatchToProps = dispatch => {
    return {
        onFetch: (restaurantId, callback) => {
            dispatch(paymentAction.fetchRestaurantPayments(restaurantId, callback));
        },
        onClear: () => {
            //czyscimy store z platnosci - aby nie pokazaly sie dla innej restauracji
            dispatch(paymentAction.clearRestaurantPayments());
            //odświeżamy kolekcje z przedawnionymi płatnościami - na potrzeby listy
            dispatch(paymentAction.fetchOverduePayments());
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RestaurantPayments);